import Script from 'next/script'
import Head from 'next/head';

export default function JsonLdFaq(props) {
  const { categoryFAQs } = props;

  const faqsStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": categoryFAQs?.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.admin_answer
      }
    })) || []
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(faqsStructuredData),
        }}
      />
    </Head>
  );
}